module.exports = __webpack_public_path__ + "e9f9802b6560646e5ed59a377fadedfb.ttf";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-regular-400.ttf
// module id = 352
// module chunks = 0